// state
const state = {
  urlVipAudio: 'http://tzxy.sina.cn/vipAudio/1661526105'
}

export default {
  namespaced: true,
  state,
  actions: {},
  mutations: {}
}
